import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Select from 'react-select';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';


function NewUser() {
    const navigate = useNavigate();
    const { Formik } = formik;
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        axiosClient.get('/roles/all').then(response => {
            const formattedOptions = response.data.data.map(role => ({
                value: role.id,
                label: role.role_name,
            }));
            setRoles(formattedOptions);
        }).catch(error => {
            console.error('Error fetching cranes:', error);
        });

    }, []);

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/settings/users">Usuarios</Link></li>
                        <li className="breadcrumb-item active">Nuevo Usuario</li>
                    </ol>
                    <h1 className="page-header mb-0">Registro de nuevo Usuario</h1>
                </div>
            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Registro de nuevo Usuario</PanelHeader>
                        <PanelBody>
                            <Formik
                                validationSchema={yup.object().shape({
                                    name: yup.string().required("Ingrese un nombre"),
                                    first_surname: yup.string().required("Ingrese el primer apellido"),
                                    second_surname: yup.string(),
                                    username: yup.string().required("Ingrese un nombre de usuario"),
                                    password: yup.string().required("Ingrese la contraseña"),
                                    confirm_password: yup.string().required("Ingrese la confirmación de la contraseña").oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden'),
                                    active: yup.boolean(),
                                    roles: yup.array()
                                        .of(
                                        yup.object().shape({
                                            label: yup.string().required(),
                                            value: yup.mixed().required(),
                                        })
                                        )
                                        .min(1, "Debes seleccionar al menos un rol")
                                        .required("Selecciona al menos un rol"),
                                    figure_type: yup.string().when('roles', {
                                        is: (roles) => roles?.some(role => role.label === 'OPERADOR'),
                                        then: schema => schema.required("Selecciona el tipo de figura"),
                                        otherwise: schema => schema.notRequired(),
                                    }),
                                    figure_rfc: yup.string().when('roles', {
                                        is: (roles) => roles?.some(role => role.label === 'OPERADOR'),
                                        then: schema =>
                                            schema
                                            .required("Campo requerido")
                                            .matches(
                                                /^([A-ZÑ&]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z\d]{3})$/,
                                                "Campo requerido"
                                            ),
                                        otherwise: schema => schema.notRequired(),
                                    }),
                                    license_number: yup.string().when('roles', {
                                        is: (roles) => roles?.some(role => role.label === 'OPERADOR'),
                                        then: schema => schema.required("Ingresa el número de licencia"),
                                        otherwise: schema => schema.notRequired(),
                                    }),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                    axiosClient.post('/users/save', values).then(response => {
                                        
                                        Swal.fire({
                                            title: 'Registro exitoso.',
                                            text: 'Se ha registrado el nuevo Usuario',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                        navigate('/settings/users');
                                    }).catch(err => {
                                        let message = '';
                                        if (err.response.data.original.code === '23505') {
                                            message = 'El nombre de usuario ya existe. Ingresa uno diferente.';
                                        } else {
                                            message = err.response.data.message;
                                        }
                                        
                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                    });
                                }}
                                initialValues={{
                                    name: '',
                                    first_surname: '',
                                    second_surname: '',
                                    username: '',
                                    password: '',
                                    active: true,
                                    roles: [],
                                    figure_type: '',
                                    figure_type_description: '',
                                    figure_rfc: '',
                                    license_number: '',

                                }}
                            >
                            {({ handleSubmit, handleChange, setFieldValue, setFieldTouched, values, touched, errors }) =>  {
                                const isOperadorSelected = values.roles.some(role => role.label === 'OPERADOR');

                                return (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="4" controlId="validationFormik01">
                                                <Form.Label>Nombre</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    placeholder="Nombre"
                                                    value={values.name}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.name}
                                                    autoComplete="off"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} md="4" controlId="validationFormik02">
                                                <Form.Label>Primer apellido</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="first_surname"
                                                    placeholder="Primer apellido"
                                                    value={values.first_surname}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.first_surname}
                                                    autoComplete="off"
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors.first_surname}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} md="4" controlId="validationFormikUsername">
                                                <Form.Label>Segundo apellido</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="second_surname"
                                                    placeholder="Segundo apellido"
                                                    value={values.second_surname}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.second_surname}
                                                    autoComplete="off"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.second_surname}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="6" >
                                                <Form.Label>Usuario</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Usuario"
                                                    name="username"
                                                    value={values.username}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.username}
                                                    autoComplete="off"
                                                    // autoComplete="off"
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors.username}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} md="6" >
                                                <Form.Label>Usuario habilitado</Form.Label>
                                                <Form.Check
                                                    type="switch"
                                                    label="Usuario habilitado"
                                                    name="active"
                                                    checked={values.active}
                                                    onChange={(e) => {
                                                        setFieldValue('active', e.target.checked);
                                                    }}
                                                />
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="6">
                                                <Form.Label>Contraseña</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    placeholder="Contraseña"
                                                    name="password"
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.password}
                                                    autoComplete="off"
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors.password}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group as={Col} md="6">
                                                <Form.Label>Repetir Contraseña</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    placeholder="Repetir Contraseña"
                                                    name="confirm_password"
                                                    value={values.confirm_password}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.confirm_password}
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors.confirm_password}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">

                                            <Form.Group as={Col} md="4" >
                                                <Form.Label>Rol</Form.Label>
                                                <Select
                                                    name="role_id"
                                                    options={roles}
                                                    className={errors.roles ? 'is-invalid' : ''}
                                                    placeholder="Selecciona uno o más roles"
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    value={values.roles}
                                                    isMulti
                                                    onChange={(e) => {
                                                        setFieldValue("roles", e);
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.roles}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                    {isOperadorSelected && (
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="4">
                                                <Form.Label>Tipo de figura</Form.Label>
                                                <Form.Select
                                                    name="figure_type"
                                                    value={values.figure_type}
                                                    onChange={(e) => {
                                                        const selected = e.target.value;
                                                        const descriptions = {
                                                            "01": "Operador",
                                                            "02": "Propietario",
                                                            "03": "Arrendador",
                                                            "04": "Notificado",
                                                            "05": "Integrante de Coordinados"
                                                        };
                                                        setFieldValue("figure_type", selected);
                                                        setFieldValue("figure_type_description", descriptions[selected] || "");
                                                    }}
                                                    isInvalid={!!errors.figure_type}
                                                >
                                                    <option value="">Seleccione una opción</option>
                                                    <option value="01">01 - Operador</option>
                                                    <option value="02">02 - Propietario</option>
                                                    <option value="03">03 - Arrendador</option>
                                                    <option value="04">04 - Notificado</option>
                                                    <option value="05">05 - Integrante de Coordinados</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.figure_type}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} md="4">
                                                <Form.Label>RFC</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="figure_rfc"
                                                    placeholder="RFC"
                                                    value={values.figure_rfc}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.figure_rfc}
                                                    autoComplete="off"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.figure_rfc}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group as={Col} md="4">
                                                <Form.Label>No. de licencia</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="license_number"
                                                    placeholder="Número de licencia"
                                                    value={values.license_number}
                                                    onChange={handleChange}
                                                    isInvalid={!!errors.license_number}
                                                    autoComplete="off"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.license_number}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
                                    )}
                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar usuario</Button>{' '}
                                                <Link to={'/settings/users'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                 );
                            }}
                            </Formik>

                        </PanelBody>
                    </Panel>
                </div>

            </div>


        </div>

    );
}

export default NewUser;